// Function to fetch and display Instagram feed
function getInstagramFeed() {
    fetch(`https://graph.instagram.com/v12.0/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${accessToken}`)
        .then(response => response.json())
        .then(data => {
            const feedContainer = document.getElementById('instagram-feed');

            // Limit the number of posts
            const limitedPosts = data.data.slice(0, postLimit);

            // Loop through each post
            limitedPosts.forEach(post => {
                const postLink = document.createElement('a');
                postLink.href = post.permalink;
                postLink.target = '_blank';
                postLink.style.position = 'relative'; // Ensure proper positioning for overlay

                const postImage = document.createElement('img');

                // Handle different media types
                if (post.media_type === 'VIDEO' || post.media_type === 'CAROUSEL_VIDEO') {
                    postImage.src = post.thumbnail_url || post.media_url; // Use thumbnail for videos
                } else {
                    postImage.src = post.media_url; // Use media URL for images
                }

                postImage.alt = post.caption || 'Instagram post';
                postImage.style.width = '100%';
                postImage.style.height = '100%';
                postImage.style.objectFit = 'cover';

                // SVG icon for Instagram
                const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svgIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                svgIcon.setAttribute('viewBox', '0 0 24 24');
                svgIcon.style.position = 'absolute';
                svgIcon.style.top = '50%';
                svgIcon.style.left = '50%';
                svgIcon.style.transform = 'translate(-50%, -50%)';
                svgIcon.style.width = '30px';
                svgIcon.style.height = '30px';
                svgIcon.style.fill = 'white';
                svgIcon.style.opacity = '0';
                svgIcon.style.transition = 'opacity 0.3s ease';
                svgIcon.innerHTML = `
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                `;

                // Add hover effects
                postLink.addEventListener('mouseover', () => {
                    svgIcon.style.opacity = '1';
                });
                postLink.addEventListener('mouseout', () => {
                    svgIcon.style.opacity = '0';
                });

                postLink.appendChild(postImage);
                postLink.appendChild(svgIcon);
                feedContainer.appendChild(postLink);
            });
        })
        .catch(error => console.error('Error fetching Instagram feed:', error));
}

// Call the function to fetch and display the Instagram feed
getInstagramFeed();
